import api from '@/lib/api';

export interface OwnerSummaryQuery {
  from?: string;
  to?: string;
  propertyId?: string;
}

export async function fetchOwnerSummary(query?: OwnerSummaryQuery) {
  const { data } = await api.get('/owner/summary', { params: query });
  return data;
}

export async function fetchOccupancy(query?: OwnerSummaryQuery) {
  const { data } = await api.get('/owner/occupancy', { params: query });
  return data;
}

export interface PayoutsQuery {
  page?: number;
  limit?: number;
}

export async function fetchPayouts(query?: PayoutsQuery) {
  const { data } = await api.get('/owner/payouts', { params: query });
  return data;
}
